import React, { Component } from "react";
import { Translation, withTranslation } from "react-i18next";
import { withRouter } from "react-router";

class TextType extends Component {
  render() {
    return (
      <Translation ns="translation">
        {(t, { i18n }) => {
          return (
            <React.Fragment>
              <h4>{t("AdminSetteliteSideMenu.option")}</h4>

              <div className="form-group">
                <label className="font-14">
                  {t("AdminSetteliteSideMenu.textTypePlaceHolder")}
                </label>

                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => this.props.handlePlaceHolderValue(e)}
                  name="placeHolder"
                  value={this.props.placeHolder}
                  placeholder={t("AdminSetteliteSideMenu.placeholder")}
                />

                <ul className="list-unstyled mb-0 mt-3">
                  <li className="pb-2">
                    <div className="form-row">
                      <div className="col-8">
                        <span className="font-size-14">
                          {t("AdminSetteliteSideMenu.hide_on_zero")}
                        </span>
                      </div>
                      <div className="col-4 ">
                        <input
                          type="checkbox"
                          onChange={(e) =>
                            this.props.handleHideOnZeroCheckBox(e)
                          }
                          checked={this.props.hide_on_zero}
                          value="hide_on_zero"
                        />
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </React.Fragment>
          );
        }}
      </Translation>
    );
  }
}
export default withRouter(withTranslation()(TextType));
